import logger from '../../../library/Core/logger';
import { axiosClient } from '../../../library/Service/axiosClient';

class OutreachDashboardService {
    static pageLoader(params: any) {
        const state: any = {};
        const { id, pageName } = params;

        // let primaryInstitute: string | undefined;
        // try {
        //     const sessionUser = JSON.parse(localStorage.getItem('user') || '{}');
        //     primaryInstitute = sessionUser?.primaryInstitute ? String(sessionUser.primaryInstitute) : undefined;
        // } catch (e) {
        //     primaryInstitute = undefined;
        // }
        // const instituteId = primaryInstitute;

        // return Promise.all([OutreachDashboardService.getSummary(instituteId)])
        
        return Promise.all([])
            .then((values) => {
                const summaryData = {
                    summary:{},
                    dispositions:{},
                    purposeOfOutreach:[],
                    topModes:[],
                    outreachByTeam:{ labels: [], data: [] },
                    topMembersTeam:[],
                    topMembersAlumni:[]
                };

                state.formConfig = {};
                state.data = {
                    // selectedOutreachDashboardInstitue: instituteId,
                    summary: summaryData?.summary ?? {
                        totalAlumni: 0,
                        alumniOutreached: 0,
                        outreachedPercent: 0,
                        totalAttempts: 0,
                        outreachDuration: '0h 0m',
                        averagePerCall: '0s',
                        crossChannel: 0,
                        notOutreached: 0,
                        notOutreachedPercent: 0,
                    },
                    dispositions: summaryData?.dispositions ?? {
                        successful: 0,
                        followUp: 0,
                        closed: 0,
                        other: 0,
                    },
                    purposeOfOutreach: summaryData?.purposeOfOutreach ?? [],
                    topModes: summaryData?.topModes ?? [],
                    outreachByTeam: summaryData?.outreachByTeam ?? { labels: [], data: [] },
                    topMembersTeam: summaryData?.topMembersTeam ?? [],
                    topMembersAlumni: summaryData?.topMembersAlumni ?? []
                };

                state.routeInfo = { id, pageName };
                state.internal = {};
                return Promise.resolve(state);
            })
            .catch(function (err) {
                logger.log(`Error in loading data for ${pageName} and the error is:`);
                console.log(err);
            });
    }

    static getSummary(instituteId?: string) {
        const query = instituteId ? `?instituteId=${instituteId}` : '';
        return axiosClient().get(
            `${process.env.REACT_APP_REPORTS_SERVER}/outreach-dashboard/summary${query}`
        );
    }
}

export default OutreachDashboardService;
